module.exports = __webpack_public_path__ + "static/media/Group78.ecfe91ce.png";